module.exports = __webpack_public_path__ + "img/6_51.94d2a401.png";